import { PublicOccurrence } from '@cademy-package/sdk-component-types';

export const getOccurrencesWithSpaces = (occurrences: PublicOccurrence[]): PublicOccurrence[] => {
    return occurrences.filter(
        (occurrence) => occurrence.available_spaces && occurrence.available_spaces > 0
    );
};
